import 'jquery';


export const getProjects = (year, categoryId, country) => {
    let version =0;
    if(typeof window.performance.navigation.type != undefined && window.performance.navigation.type == 2){
        version = Math.floor(Math.random() * (99999 - 10 + 1)) + 10;
    }
    if(country!= undefined && country!= ""){
        return $.get(`/lifeChallengeObjects/${year}/${categoryId}?country_code=${country}&v=${version}`);
    }else{
        return $.get(`/lifeChallengeObjects/${year}/${categoryId}?v=${version}`);
    }

};

export const vote = (year, projId, rating) => {
    return $.post('/lifeChallengeVote/' + year,
        {
            id: projId,
            vote: rating
        });
};


export const getNextUrl = (year, projectID) => {
    return $.get(`/lifeChallenge/${year}/next/${projectID}`);
};

export const getVote = (year, categoryId) => {
    return $.get(`/lifeChallengeObjects/${year}/${categoryId}`);
};